import { type Module } from "vuex";
import type { DefaultApi } from "@/api";
import { TodoGuidance } from "@/models/todo_guidance";
import type { TodoGuidances } from "@/models/todo_guidances";
import type { State as RootState } from "@/stores";
export interface State {
  candidateGuidances?: TodoGuidances;
}
export const module: Module<State, RootState> = {
  namespaced: true,
  state: {
    candidateGuidances: {},
  },
  actions: {
    async getCandidateTodoGuidance(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getCandidateTodoGuidance(
        positionId,
        candidateId,
      );
      const candidateGuidance = new TodoGuidance(response.data);
      commit("setCandidateGuidance", {
        candidateId,
        candidateGuidance,
      });
      return candidateGuidance;
    },
    async postCandidateTodoGuidance(
      { commit },
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postCandidateTodoGuidance(
        positionId,
        candidateId,
      );
      const candidateGuidance = new TodoGuidance(response.data);
      commit("setCandidateGuidance", {
        candidateId,
        candidateGuidance,
      });
      return candidateGuidance;
    },
    async postCandidateTodoGuidanceMarkAsCompleted(
      {},
      {
        positionId,
        candidateId,
      }: {
        positionId: number;
        candidateId: number;
      },
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      return api.postCandidateTodoGuidanceMarkAsCompleted(
        positionId,
        candidateId,
      );
    },
  },
  mutations: {
    setCandidateGuidance(
      state,
      {
        candidateId,
        candidateGuidance,
      }: {
        candidateId: number;
        candidateGuidance: TodoGuidance;
      },
    ) {
      state.candidateGuidances = Object.assign({}, state.candidateGuidances, {
        [candidateId]: candidateGuidance,
      });
    },
  },
};
